import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted, computed, onBeforeUnmount } from "vue";
import moment from 'moment';
import 'moment/locale/fr';
import 'moment/locale/ar';


const __default__ = {
  name: "DateWidget",
};


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    fontFamily: {},
    fontSize: {},
    fontColor: {},
    fontWeight: {}
  },
  setup(__props: any) {

const props = __props;

// const language = ref("en");
// const getLanguage=()=>{
//   const lang = localStorage.getItem("Language") || "en";
//   if(lang == "fr"){
//     language.value = "fr";
//     moment.locale('fr');
//   }else if(lang == "ar"){
//     language.value = "ar";
//     moment.locale('ar');
//   }else {
//     language.value = "en";
//     moment.locale('en');
//   }
// }

const currentDate = ref(new Date());
const dateTimer = ref<number | null>(null);

const formattedDate = computed(() => {
  return moment(currentDate.value).locale('fr').format('dddd D MMM, YYYY').replace(/^([a-zA-Z])/,
    (match) => match.toUpperCase()
  );
  // if (language.value === 'ar') {
  //   const date = moment(currentDate.value).locale('ar');
  //   //format date as arabic 
  //   const formatted = date.format('dddd D MMMM، YYYY');
  //   //replace arabic digits with latin
  //   return formatted.replace(/[٠-٩]/g, d => '0123456789'['٠١٢٣٤٥٦٧٨٩'.indexOf(d)]);
  // }
  // //default format for other langs
  // return moment(currentDate.value).format('dddd D MMM, YYYY').replace(/^([a-zA-Z])/,
  //   (match) => match.toUpperCase()
  // );
});

onMounted(() => {
  // getLanguage();
  moment.locale('fr'); 
  updateDate();
  // update date every minute
  dateTimer.value = window.setInterval(updateDate, 60000);
});

onBeforeUnmount(() => {
  if (dateTimer.value) {
    window.clearInterval(dateTimer.value);
  }
});

function updateDate() {
  currentDate.value = new Date();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "date-widget",
    style: _normalizeStyle({
      fontFamily: _ctx.fontFamily,
      fontSize: `${_ctx.fontSize}px`,
      color: _ctx.fontColor,
      fontWeight: _ctx.fontWeight === 'bold' ? 'bold' : 'normal',
      fontStyle: _ctx.fontWeight === 'italic' ? 'italic' : 'normal',
      textDecoration: _ctx.fontWeight === 'underline' ? 'underline' : 'none',
    })
  }, _toDisplayString(formattedDate.value), 5))
}
}

})